import React from "react";
import IbssChip from "../../Navigation/Chip/IbssChip";
import { Typography } from "@mui/material";
import { appContext } from "../../../AppContext";
import { DateTime } from "luxon";

class GetAnnouncementDetails extends React.Component<Props> {
    private get labels() { return appContext().labels; }
    
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    public getEventStatus(itemDate: DateTime, isWaitingListAllowed: boolean, eventCapacity: number, eventAttendees: number, userIsAttending: boolean ): React.ReactNode
    {
        
        const currentDate = DateTime.now();

        if (itemDate <= currentDate)
        {
            return <p>-</p>;
        }

        const spacesLeft = Math.max(0, eventCapacity - eventAttendees);

        if (userIsAttending)
        {
            return ( 
                <Typography variant="body2" color="textSecondary">                           
                    <IbssChip
                        label={this.labels.funcEventStatusYouAreIn_S}
                        sx={{
                            backgroundColor: `var(${"--ui-primary-pastel"})`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography> 
            );
        }

        if (spacesLeft <= 0 && isWaitingListAllowed)
        {
            return (                                    
                <Typography variant="body2" color="textSecondary">  
                    <IbssChip
                        label={this.labels.funcEventStatusJoinWaitlist_S}
                        sx={{
                            backgroundColor: `var(${"--ui-background"})`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }

        if (spacesLeft > 0 && spacesLeft <= 10)
        {
            return (                                    
                <Typography variant="body2" color="textSecondary">  
                    <IbssChip
                        label={`${spacesLeft} ${this.labels.funcEventStatusSpacesLeft_S}`}
                        sx={{
                            backgroundColor: `var(${"--ui-error-pastel"})`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }

        if (spacesLeft > 0)
        {
            return (                                    
                <Typography variant="body2" color="textSecondary">
                    <IbssChip
                        label={this.labels.HubLabelAvailable}
                        sx={{
                            backgroundColor: `var(${"--ui-success-pastel"})`,
                            color:  "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }

        return <p>-</p>;
    }
    
    public getNotificationStatus(priority: number): React.ReactNode
    {
        if(priority === 1 )
        {
            return (
                <Typography variant="body2" color="textSecondary">
                    <IbssChip
                        label={this.labels.HubLabelHighPriority}
                        sx={{
                            backgroundColor: `var(--ui-error-pastel)`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }
        else if(priority === 2 )
        {
            return (
                <Typography variant="body2" color="textSecondary">
                    <IbssChip
                        label={this.labels.funcAnouncementPriorityMedium_Short}
                        sx={{
                            backgroundColor: `--ui-background`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }
        else
        {
            return (
                <Typography variant="body2" color="textSecondary">
                    <IbssChip
                        label={this.labels.HubLabelLowPriority}
                        sx={{
                            backgroundColor: `--ui-background`,
                            color: "var(--ui-secondary)",
                        }}
                    />
                </Typography>
            );
        }
    }
}

export { GetAnnouncementDetails };

interface Props {}
